<template>
  <v-row class="main">
    <v-row>
      <v-col class="ml-4 pb-0">
        <h2 class="primary--text font-weight-medium">
          {{ geographyTemplate.title | replaceStateName(selectedItemValue) }}
        </h2>
      </v-col>
    </v-row>
    <v-col cols="8" class="main-body">
      <template v-if="geographyTemplate.primaryImage">
        <v-img :aspect-ratio="16 / 9" :src="geographyTemplate.primaryImage">
        </v-img>
        <p class="caption">{{ geographyTemplate.imageCaptionText }}</p>
      </template>
      <div class="main-message pb-2">
        <p class="pre-wrap body-2">
          {{ geographyTemplate.stateOverviewText }}
        </p>
      </div>
      <v-row v-if="hasAssets">
        <v-col>
          <h4 class="body-1 primary--text">
            NextEra Energy Resources Assets in {{ selectedItemValue }}
          </h4>
        </v-col>
      </v-row>
      <v-row class="resource-assets text-center px-4">
        <v-col
          class="pb-0"
          v-for="index in geographyTemplate.assetsState.length"
          :key="index"
          v-show="getValueAsset(index - 1, 'valueField')"
        >
          <p class="font-weight-black title accent--text">
            {{ getValueAsset(index - 1, 'valueField') }}
          </p>
          <p class="caption">
            {{ getValueAsset(index - 1, 'labelField') }}
            {{ getValueAsset(index - 1, 'statusField') }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p class="primary--text mb-1">
            About {{ geographyTemplate.primaryCompany }}
          </p>
          <p class="body-2 mb-1 pre-wrap caption">
            {{
              geographyTemplate.companyInfos[geographyTemplate.primaryCompany]
            }}
          </p>
        </v-col>
      </v-row>
    </v-col>
    <!--- SIDEBAR --->
    <v-col
      cols="4"
      class="pr-6 sidebar white--text text-center d-flex flex-column"
    >
      <v-row>
        <v-col class="primary">
          <h3 class="font-weight-black title blue-column-title pb-3">
            Economic Impact
          </h3>
        </v-col>
      </v-row>
      <v-row
        v-for="index in geographyTemplate.factoidsState.length"
        :key="`factoid-${index}`"
        v-show="getFactoid(index - 1)"
      >
        <v-col class="primary" v-if="getFactoid(index - 1)">
          <h2 class="font-weight-medium">{{ getFactoid(index - 1) }}</h2>
          <p class="body-1">{{ getFactoid(index - 1, 'label') }}</p>
        </v-col>
      </v-row>
      <v-row v-show="getPromoData()" class="mt-4 mb-2">
        <v-col class="callout-box">
          <p class="title">
            {{ getPromoData().title }}
          </p>
          <p class="body-2">
            {{ getPromoData().description }}
          </p>
          <p class="display-2 font-weight-bold">
            {{ getPromoData().value }}
          </p>
          <p class="caption">
            {{ getPromoData().source }}
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import factsheetLogic from '@/mixins/factsheetLogic';

export default {
  name: 'StateFactsheet',
  mixins: [factsheetLogic],
  filters: {
    replaceStateName: function (value, replacement) {
      if (!value) return '';
      value = value.toString();
      return value.replace('{stateName}', replacement);
    }
  }
};
</script>

<style lang="scss" scoped>
p.body-2 {
  line-height: 1.125;
}

.pre-wrap {
  white-space: pre-line;
  word-wrap: break-word;
  font-family: inherit;
}

.sidebar {
  .blue-column-title {
    border-bottom: 2px solid white;
  }
  .callout-box {
    background-color: $ne-green;
    .title {
      line-height: 1.1;
    }
  }
}

.main {
  color: $ne-textcolor;
  .resource-assets {
    .col {
      border-bottom: thin solid rgba(0, 0, 0, 0.12);
    }
    .title {
      line-height: 1;
    }
    .caption {
      line-height: 1.1;
    }
  }
}
</style>
